import { useState, useMemo } from "react";
import CreateAccountPanel from "./CreateAccountPanel";
import "./Login.css";
import LoginPanel from "./LoginPanel";

const LOGIN_PAGES = {
  LOGIN: "login",
  CREATE_ACCOUNT: "create_account",
};
const Login = (props) => {
  const [loginPageState, setLoginPageState] = useState(LOGIN_PAGES.LOGIN);
  // const { onCickCreateAccount } = props;

  const onCickCreateAccount = () => {
    setLoginPageState(LOGIN_PAGES.CREATE_ACCOUNT);
  };

  return (
    <div className="unauthed-home-container">
      {loginPageState === LOGIN_PAGES.LOGIN ? (
        <div className="login-page-container">
          <div>
            <LoginPanel />
            or
            <div
              className="create-account-button"
              onClick={onCickCreateAccount}
            >
              Create Account
            </div>
          </div>
        </div>
      ) : null}
      {loginPageState === LOGIN_PAGES.CREATE_ACCOUNT ? (
        // <div className="create-account-page-container">
          <CreateAccountPanel />
        // </div>
      ) : null}
    </div>
  );
};

export default Login;
